import { ConversionPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantAppTopic } from "@redotech/redo-merchant-app-common/events/merchant-app-event-server";
import { MerchantAppEventServerContext } from "@redotech/redo-merchant-app-common/events/merchant-app-event-server-provider";
import { NotificationType } from "@redotech/redo-support-common/notification";
import { showNotification } from "@redotech/redo-web/alert";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMerchantRoutes } from "../../../redo-suite/merchant-routes";

/**
 * Register listener for conversion notifications.
 */
export function useEffect_conversionNotifications() {
  const navigate = useNavigate();
  const eventServer = useRequiredContext(MerchantAppEventServerContext);
  const routes = useMerchantRoutes();

  const canViewConversion = useHasPermission(
    ConversionPermissions.ACCESS_CONVERSION,
  );

  useEffect(() => {
    if (!canViewConversion) {
      return;
    }

    const unlistenCallback = eventServer.subscribe({
      topic: MerchantAppTopic.USER_NOTIFICATIONS,
      callback: (value) => {
        switch (value.type) {
          case NotificationType.CONVERSION__SPLIT_AGENT_COMPLETED: {
            showNotification({
              title: "Your A/B test is ready to review",
              description:
                "Review it now or find it in your list of upcoming tests to review later.",
              primaryButton: {
                text: "Review now",
                onClick: () => {
                  navigate(
                    routes.getConversionSubRoute(
                      `ab-tests/edit-tree?id=${value.splitId}`,
                    ),
                  );
                },
              },
            });
            break;
          }
          default: {
            break;
          }
        }
      },
    });
    return () => unlistenCallback();
  }, [eventServer, navigate, routes, canViewConversion]);
}
